import { useEffect, useState } from "react";

const KEY = "fsc_fee_currency";
const EVENT = "fsc:fee-currency";

// Remembers whether fees are shown in FMI or USD, shared across pages and tabs
export function useFeeCurrency() {
  const [currency, setCurrency] = useState(() => (localStorage.getItem(KEY) === "USD" ? "USD" : "FMI"));
  useEffect(() => {
    const sync = () => setCurrency(localStorage.getItem(KEY) === "USD" ? "USD" : "FMI");
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const toggle = () => {
    localStorage.setItem(KEY, currency === "FMI" ? "USD" : "FMI");
    window.dispatchEvent(new Event(EVENT));
  };
  return { currency, toggle };
}

export const fmtFmi = (v) => (v < 0.000001 ? "<0.000001" : v.toFixed(6)) + " FMI";
export const fmtUsd = (v) => `$${v < 0.01 ? v.toFixed(4) : v.toFixed(2)}`;

/** Formats an FMI amount in the chosen currency; falls back to FMI when no price is known. */
export const formatFee = (fmi, usdPrice, currency) =>
  currency === "USD" && usdPrice ? fmtUsd(fmi * usdPrice) : fmtFmi(fmi);

export const FeeToggle = ({ currency, onToggle, testId = "fee-currency-toggle" }) => (
  <button type="button" data-testid={testId} onClick={onToggle} title="Switch fee currency"
    className="inline-flex items-center rounded-full border border-[#2A2411] bg-[#050505] p-0.5 text-[10px] font-semibold">
    {["FMI", "USD"].map((c) => (
      <span key={c} className={`px-2 py-0.5 rounded-full transition-colors ${currency === c ? "bg-[#D4AF37] text-black" : "text-zinc-500"}`}>{c}</span>
    ))}
  </button>
);
